import React, { useState } from "react";

import { Chip, Popover, Stack } from "@mui/material";
import { useAccountSelector, useDealActions, useInvestorsSelector, useReportsFiltersSelector } from "store";
import { ReportFilters } from "store/types/reports";

import { InvestorFilterPicker } from "./";

interface InvestorFilterPickerState {
  anchorEl: Element;
  options: { id: number; name: string }[];
  incomingValue: string[];
  onSubmit: (value: string[]) => void;
}

export const InvestorFilters: React.FC<{
  onFiltersChange: (filters: ReportFilters) => void;
}> = ({ onFiltersChange }) => {
  const investors = useInvestorsSelector();
  const filters = useReportsFiltersSelector();
  const [filtersToPick, setFiltersToPick] = useState<InvestorFilterPickerState | null>(null);
  const { setMeasureDataTableFiltersAction: setDataFilters } = useDealActions();
  const { show_global_investor_filter } = useAccountSelector() || {};

  const investorsFilter = (filters.Investor as string[]) || [];

  const removeFilter = (): void => {
    const updatedFilters = { ...filters };
    if (updatedFilters.Investor) {
      delete updatedFilters.Investor;
    }
    onFiltersChange(updatedFilters);
    if (show_global_investor_filter) {
      setDataFilters({ investors: [] });
    }
  };

  const updateInvestorFilter = (e: React.MouseEvent) => {
    setFiltersToPick({
      anchorEl: e.currentTarget,
      options: investors.map(({ id, name }) => ({ id, name })),
      incomingValue: investorsFilter,
      onSubmit: (newValue) => {
        onFiltersChange({ ...filters, Investor: newValue });
        if (show_global_investor_filter) {
          const investorsToFilters = investors
            .filter((investor) => newValue.includes(investor.name))
            .map((investor) => ({ id: investor.id, name: investor.name }));
          setDataFilters({ investors: investorsToFilters });
        }
      }
    });
  };

  const handleCloseFilterPicker = () => setFiltersToPick(null);

  return (
    <Stack sx={{ gap: "0px", width: "auto" }}>
      <Stack
        direction="row"
        sx={{
          alignItems: "center",
          flexWrap: "wrap",
          gap: "15px",
          maxHeight: "125px",
          overflowX: "hidden",
          overflowY: "auto"
        }}
      >
        <Chip
          size="small"
          label={`Investors (${investorsFilter.length})`}
          onDelete={removeFilter}
          onClick={updateInvestorFilter}
        />
      </Stack>
      <Popover
        open={Boolean(filtersToPick)}
        anchorEl={filtersToPick?.anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        onClose={handleCloseFilterPicker}
        disableEnforceFocus
        disableAutoFocus
      >
        <InvestorFilterPicker {...filtersToPick} onCancel={handleCloseFilterPicker} onClose={handleCloseFilterPicker} />
      </Popover>
    </Stack>
  );
};
